<template>
    <div>
        <div class="bubbleList-body-body" @click="chooseItem(subItem)" v-for="subItem in list">

            <div class="left"><img class="logo" v-if="subItem.logo" :src="subItem.logo"></div>

            <div class="right">
                <div class="m1" v-if="subItem.tit">{{ subItem.tit }}</div>
                <div class="m2" v-if="subItem.des">{{ subItem.des }}</div>
                <div class="bottom">
                    <div class="bottom-left">
                        <div class="m3" v-if="isNumSet(subItem.mon)"><span>{{ subItem.mon }}</span></div>
                        <div class="m4" v-if="isNumSet(subItem.count)">x<span>{{ subItem.count }}</span></div>
                    </div>
                    <div class="bottom-right m4" v-if="isNumSet(subItem.much)">
                        <span>{{ subItem.much }}</span>件已售
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    chooseItem(item) {
      this.$emit('chooseItem', item);
    },
    isNumSet(num) {
      return  num || String(num) === '0';
    },
  },
};
</script>

<style lang="less" scoped>
.bubbleList-body-body {
    display: flex;
    justify-content: space-between;
    padding: 12px 0px;
    height: 72px;

    .left {
        flex: 0 0 72px;
        height: 72px;
        width: 72px;

        .logo {
            width: 100%;
            height: 100%;
        }
    }

    .right {
        // max-width: 254px;
        // min-width: 162px;
        width: 170px;

        .m1 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #262d3d;
        }

        .m2 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 6px 0 12px;
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            color: #78849e;
        }

        .bottom {
            display: flex;
            justify-content: space-between;
            padding-bottom: 30px;

            .bottom-left {
                flex: 1;
                display: flex;

                .m3 {
                    font-family: Helvetica Neue;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 12px;
                    line-height: 16px;
                    color: #ff8147;
                    padding-right: 10px;
                }
            }
            .bottom-right {
                flex: 0 0 80px;
                text-align: right;
            }
            .m4 {
                font-family: PingFang SC;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #78849e;
            }
        }
    }
}</style>
